import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { isWeb } from "@madmedical/utils";
import { useTranslation } from "@madmedical/i18n";
import ListHeader from "../molecules/ListHeader";
import { useDevices } from "../providers/device";
import EmptyState from "../atoms/EmptyState";
import { DeviceItem } from "./DeviceItem";
const DeviceList = ({ title, deviceTypes }) => {
    const { devices } = useDevices();
    const { t } = useTranslation();
    return (_jsxs(_Fragment, { children: [devices.length > 0 && title && _jsx(ListHeader, { title: title }), devices.length ? (devices
                .filter((device) => !deviceTypes || deviceTypes.includes(device.type))
                .map((item, index) => (_jsx(DeviceItem, { device: item }, index)))) : (_jsx(EmptyState, { title: isWeb ? t("measures:noData") : t("noDevice"), message: isWeb
                    ? t("noResultsAfterFilter")
                    : t("tryAgainOrNewDevice"), my: 4 }))] }));
};
export default DeviceList;
